import "./loader.css";

export const Loader = () => {
  return (
    <div id="dots1">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};
